import React = require("react");
import ReactDOM = require("react-dom");
import Dialog from "material-ui/Dialog";
import FlatButton from "material-ui/FlatButton";
import diyLightTheme = require("diy/material-ui/diyLightTheme");
import {format} from "diy/util/string";
import l10n from "diy/util/l10n";

interface PremiumDialogProps extends React.Props<PremiumDialog> {
    messagePart1: string;
    messagePart2: string;
    btnText: string;
    btnCancelText?: string;
    btnAction: () => any;
    btnCancelAction?: () => any;
}

class PremiumDialog extends React.Component<PremiumDialogProps, {}> {
    static childContextTypes: React.ValidationMap<any> = {
        muiTheme: React.PropTypes.object
    };

    getChildContext() {
        return {
            muiTheme: diyLightTheme
        };
    }

    render() {
        const actions = [
            (this.props.btnCancelText) ?
            <FlatButton
                label={this.props.btnCancelText}
                secondary={true}
                onTouchTap={this.props.btnCancelAction}
                data-test-id="bigstock-cancel-btn"
            /> :
            null,
            <FlatButton
                label={this.props.btnText}
                primary={true}
                onTouchTap={this.props.btnAction}
                data-test-id="bigstock-action-btn"
            />,
        ];

        return (
            <div>
            <Dialog
                actions={actions}
                modal={true}
                open={true}
                style={{zIndex: 200002}}
                contentStyle={{maxWidth: '450px'}}
                bodyStyle={{padding: 0}}
            >
                {this.props.children}
            </Dialog>
            </div>
        );
    }
}

let rootEl: HTMLElement = null;

const styles = {
    title: {fontWeight: 500, fontSize: "16px", marginBottom: "12px"},
    paragraph: {fontSize: "13px", margin: "6px 0px"},
    body: {padding: "24px"},
    imgWrapper: {
        width: "100%",
        height: "200px",
        overflow: "hidden",
    },
    imgDiv: {
        width: "100%",
        height: "240px",
        backgroundSize: "cover",
        backgroundPosition: "50% 50%",
        backgroundImage: "",
    }
};

export function showInitialDialog(btnAction: () => any, maxNumberOfImages: string) {
    rootEl = document.createElement("div");
    document.body.appendChild(rootEl);

    const messageTitle = l10n("filemanager.bigstockSection.initialMessage.title").replace(/&amp;/, '&');
    const part1Text = l10n("filemanager.bigstockSection.initialMessage.part1");
    const messagePart1 = format(part1Text, {
        "maxNumberOfImages": maxNumberOfImages
    });
    const messagePart2 = l10n("filemanager.bigstockSection.initialMessage.part2");

    const btnText = l10n("filemanager.bigstockSection.initialMessage.button");

    ReactDOM.render(
        <PremiumDialog
            messagePart1={messagePart1}
            messagePart2={messagePart2}
            btnText={btnText}
            btnAction={(btnAction)}
        >
        <div style={styles.body} data-test-id="bigstock-dialog-initial-content">
            <div style={styles.title}>{messageTitle}</div>
            <div style={styles.paragraph}>{messagePart1}</div>
            <div style={styles.paragraph}>{messagePart2}</div>
        </div>
        </PremiumDialog>
        ,
        rootEl);
};

export function showLimitDialog(
    btnAction: () => any, btnCancelAction: () => any, maxNumberOfImages: string, url: string
) {
    rootEl = document.createElement("div");
    document.body.appendChild(rootEl);

    const messageTitle = l10n("filemanager.bigstockSection.limitMessage.title");
    const part1Text = l10n("filemanager.bigstockSection.limitMessage.part1");
    const messagePart1 = format(part1Text, {
        "maxNumberOfImages": maxNumberOfImages
    });
    const messagePart2 = l10n("filemanager.bigstockSection.limitMessage.part2");

    const btnGoText = l10n("filemanager.bigstockSection.limitGo.button");
    const bntCancelText = l10n("filemanager.bigstockSection.limitCancel.button");

    styles.imgDiv.backgroundImage = "url('" + url + "')";

    ReactDOM.render(
        <PremiumDialog
            messagePart1={messagePart1}
            messagePart2={messagePart2}
            btnText={btnGoText}
            btnAction={btnAction}
            btnCancelText={bntCancelText}
            btnCancelAction={btnCancelAction}
        >
            <div data-test-id="bigstock-dialog-limit-content">
                <div style={styles.imgWrapper}>
                    <div style={styles.imgDiv}></div>
                </div>
                <div style={styles.body}>
                    <div style={styles.title}>{messageTitle}</div>
                    <div style={styles.paragraph}>{messagePart1}</div>
                    <div style={styles.paragraph}>{messagePart2}</div>
                </div>
            </div>
        </PremiumDialog>
        ,
        rootEl);
};

export function closeDialog() {
    if (rootEl) {
        ReactDOM.unmountComponentAtNode(rootEl);
        document.body.removeChild(rootEl);
    }
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/filemanager/sources/premiumDialog.tsx
 **/